import E from 'services/emitter';

export let $el;

export function setScrollable ($scrollable) {
  if ($el)
    $el.removeEventListener('scroll', emitOnScroll);
  $el = $scrollable;
  $el.addEventListener('scroll', emitOnScroll);
}
setScrollable(window);

let lastScrollTop = $el.scrollTop;
export function emitOnScroll () {
  const { scrollTop, offsetHeight, scrollHeight } = ($el === window ? document.documentElement : $el);
  E.emit('scroll', scrollTop - lastScrollTop, { scrollTop, offsetHeight, scrollHeight });
  lastScrollTop = scrollTop;
}

export function scroll (y, x = 0) {
  if (!arguments.length)
    return $el.scrollTop;
  $el.scroll(x, y);
}

let scrollPreventCount = 0;
export function preventScroll (bool = true) {
  scrollPreventCount += bool ? 1 : -1;
  $el.style.overflow = scrollPreventCount ? 'hidden' : '';
}

export function onScroll (fn) {
  E.on('scroll', fn);
  return () => E.off('scroll', fn);
}

export function offScroll (fn) { E.off('scroll', fn) }
